<app-page-header
  [title]="isLoggedIn ? 'Atualizar meu cadastro' : 'Cadastrar'"
  [titleIcon]="isLoggedIn ? 'pi pi-pencil' : 'pi pi-plus'"
  [subtitle]="
    !isLoggedIn
      ? 'Preencha os campos abaixo para finalizar o cadastro.'
      : 'Aqui você pode consultar e atualizar seu cadastro.'
  "
  [headerFlexWrap]="false">
  <div class="container-button-close">
    <button type="button" class="btn-close" aria-label="Close" (click)="dialogRef.close()"></button>
  </div>
</app-page-header>

<mat-dialog-content [ngClass]="{ 'logged-in': isLoggedIn }">
  <div class="row p-3">
    @if (!isLoggedIn) {
      <div class="col-sm-12 col-md-4 col-lg-6 d-flex justify-content-center w-100">
        <div class="modal-body--social-signup">
          <button class="already-has-account" (click)="openModalLogin()">
            <span>{{ "shared.modal.signup.text.already-have-an-account" | translate }}</span>
            <br />
            <span class="already-has-account--signup-text">{{
              "shared.modal.signup.anchor.already-have-an-account" | translate
            }}</span>
          </button>
        </div>
      </div>
    }

    <div class="col-sm-12 col-md-12 col-lg-12">
      <app-finish-sign-up-form
        (formSubmitClick)="handleFormSubmit($event)"
        [userData]="userData"
        [isLoading]="isLoading" />
    </div>
  </div>
</mat-dialog-content>
